import {Typography} from "@material-ui/core";
import React from "react";

const Home = () => {
    return (
        <>
            <Typography variant="h1">
                Welcome to Acquire Interactive
            </Typography>
            <Typography variant="body1" paragraph>
                General information about posting can be found here.
            </Typography>
        </>
    );
};

export default Home;
